import mainStyle from "../mainStyle.module.scss";
import React, { useState, useEffect, memo } from "react";
import { useAuth } from "contexts/AuthContext";
import { useTheme } from "@mui/material/styles";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { Typography, Box, TextField, InputAdornment } from "@mui/material";
import useDataSourceManager from "hooks/useDataSourceManager";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show.svg";
import { ReactComponent as FinishIcon } from "assets/images/icons/icn_finish.svg";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import { getServerURL, getAppApiURL } from "../../../utils/serverUrl";
import { postLogoutWithFormBody } from "../../../utils/logout";

const ordID = process.env.REACT_APP_ORGANIZATIONNAME;
const checkMockup = process.env.REACT_APP_IS_MOCKUP;
const ModalforPassword = (props) => {
  const { title, content, cancelBtn, saveBtn, setOpenModal } = props;
  const theme = useTheme();
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } =
    useDataSourceManager();

  const { token } = useAuth();
  const [userToken, setUserToken] = useState(null);

  // const [originPw, serOriginPw] = useState('')

  const [currentPw, setCurrentPw] = useState("");
  const [ifNgCurrentPw, setIfNgCurrentPw] = useState(false);
  const [currentPwErr, setCurrentPwErr] = useState("");
  const [showCurrentPw, setShowCurrentPw] = useState(false);

  const [newPw, serNewPw] = useState("");
  const [ifNgNewPw, setIfNgNewPw] = useState(false);
  const [newPwErr, serNewPwErr] = useState("");
  const [showNewPw, setShowNewPw] = useState(false);

  const [newPw2, serNewPw2] = useState("");
  const [ifNgNewPw2, setIfNgNewPw2] = useState(false);
  const [newPw2Err, serNewPw2Err] = useState("");
  const [showNewPw2, setShowNewPw2] = useState(false);

  const serverURL = getServerURL();
  const serverApiURL = getAppApiURL();

  const navigate = useNavigate();

  const handleCurrentPw = (e) => {
    let tmpVal = e.target.value;
    setCurrentPw(tmpVal);
  };
  const handleNewPw = (e) => {
    let tmpVal = e.target.value;
    serNewPw(tmpVal);
  };
  const handleNewPw2 = (e) => {
    let tmpVal = e.target.value;
    serNewPw2(tmpVal);
  };

  const handleBlurCurrentPw = () => {
    if (currentPw === "") {
      setIfNgCurrentPw(true);
      setCurrentPwErr("Please enter your password");
    } else {
      setIfNgCurrentPw(false);
      setCurrentPwErr("");
    }
  };

  const handleBlurNewPw = () => {
    let checkRegex = validatePassword(newPw);
    if (checkRegex) {
      setIfNgNewPw(false);
      serNewPwErr("");

      if (newPw !== newPw2) {
        setIfNgNewPw2(true);
        serNewPw2Err(
          "The new password and the confirmed password must be the same",
        );
      } else {
        setIfNgNewPw2(false);
        serNewPw2Err("");
      }
    } else {
      setIfNgNewPw(true);
      serNewPwErr(
        "The password must contain uppercase and lowercase letters, numbers and symbols",
      );
    }
  };
  const handleBlurNewPw2 = () => {
    let checkRegex = validatePassword(newPw2);
    if (checkRegex) {
      if (newPw !== newPw2) {
        setIfNgNewPw2(true);
        serNewPw2Err(
          "The new password and the confirmed password must be the same",
        );
      } else {
        setIfNgNewPw2(false);
        serNewPw2Err("");

        setIfNgNewPw(false);
        serNewPwErr("");
      }
    } else {
      setIfNgNewPw2(true);
      serNewPw2Err(
        "The password must contain uppercase and lowercase letters, numbers and symbols",
      );
    }
  };

  const handleShowCurrentPw = (e) => {
    let tmpVal = showCurrentPw;
    setShowCurrentPw(!tmpVal);
  };
  const handleShowNewPw = (e) => {
    let tmpVal = showNewPw;
    setShowNewPw(!tmpVal);
  };
  const handleShowNewPw2 = (e) => {
    let tmpVal = showNewPw2;
    setShowNewPw2(!tmpVal);
  };

  const [openFinishLog, setOpenFinishLog] = useState(false);
  const [openSubCheck, setOpenSubCheck] = useState(false);
  const handleSubClose = (e) => {
    setOpenSubCheck(false);
  };
  const handleSubOK = (e) => {
    setOpenSubCheck(false);
    setOpenModal(false);
  };
  const handleFinishOK = (e) => {
    if (checkMockup === "true") {
      setOpenSubCheck(false);
      setOpenModal(false);
    } else {
      logoutUser();
    }
  };
  const handleClose = () => {
    setOpenSubCheck(true);
    // setOpenFinishLog(true)
  };
  const handleSave = () => {
    saveUserPW();
  };

  const logoutUser = async () => {
    try {
      setOpenSubCheck(false);
      setOpenModal(false);
      const token = localStorage.getItem("token");
      await postLogoutWithFormBody({
        serverURL,
        token,
        redirectUri: `${serverApiURL}/login`,
      });
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const saveUserPW = async (updateUser) => {
    if (currentPw === "" || newPw === "" || newPw2 === "") {
      if (currentPw === "") {
        setIfNgCurrentPw(true);
        setCurrentPwErr("Please enter your password");
      }
      if (newPw === "") {
        setIfNgNewPw(true);
        serNewPwErr("Please enter your password");
      }
      if (newPw2 === "") {
        setIfNgNewPw2(true);
        serNewPw2Err("Please enter your password");
      }
      return;
    } else if (newPw !== newPw2) {
      setIfNgNewPw(true);
      serNewPwErr("The new password does not match the confirmed password");
      setIfNgNewPw2(true);
      serNewPw2Err("The new password does not match the confirmed password");
      return;
    } else {
      if (checkMockup === "true") {
        setOpenFinishLog(true);
      } else {
        // const updateData = new URLSearchParams();
        // updateData.append("userOwner", ordID);
        // updateData.append("userName", userToken.name);
        // updateData.append("oldPassword", currentPw);
        // updateData.append("newPassword", newPw);
        let updateData = {
          userOwner: ordID,
          userName: userToken.name,
          oldPassword: currentPw,
          newPassword: newPw,
        };

        // const response = await UserService.updateUserPassword(updateData, token)
        const response = await sendRequest(
          "casdoor/UserService/.updateUserPassword",
          null,
          null,
          updateData,
        );

        if (response.status !== "ok") {
          let errMsg = response.msg;
          setIfNgCurrentPw(true);

          if (errMsg.includes("||||")) {
            const [tmpMsgRaw, replaceVarRaw] = errMsg.split("||||");
            const tmpMsg = tmpMsgRaw.trim();
            const replaceVar = replaceVarRaw.trim();
            const targetStr = "%d";
            const replaceErrMsg = replaceVariableMsg(
              tmpMsg,
              targetStr,
              replaceVar,
            );

            setCurrentPwErr(replaceErrMsg);
          } else {
            //不用切割替換
            setCurrentPwErr(errMsg);
          }
        } else {
          setIfNgCurrentPw(false);
          setCurrentPwErr("");
          setIfNgNewPw(false);
          serNewPwErr("");
          setIfNgNewPw2(false);
          serNewPw2Err("");
          setOpenFinishLog(true);
        }
      }
    }
  };

  const replaceVariableMsg = (originMsg, target, replaceAry) => {
    let index = 0;

    // 對 target 進行正則轉譯
    // function escapeRegExp(string) {
    //   return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // }
    // escapeRegExp(target);
    const escapedTarget = target.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const targetRegex = new RegExp(escapedTarget, "g");

    return originMsg.replace(targetRegex, () => {
      return index < replaceAry.length ? replaceAry[index++] : target;
    });
  };

  const validatePassword = (password) => {
    // (?=.*\d)           : 至少包含一個數字
    // (?=.*[a-z])        : 至少包含一個小寫字母
    // (?=.*[A-Z])        : 至少包含一個大寫字母
    // (?=.*[!@#$%^&*()_+]) : 至少包含一個符號
    // .{8,}              : 密碼長度至少為8個字符
    const passwordRegex =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,}$/;
    return passwordRegex.test(password);
  };

  useEffect(() => {
    if (checkMockup !== "true") {
      setUserToken(jwtDecode(token));
    }
  }, []);

  return (
    <>
      <div
        className={mainStyle["modal_Block"]}
        style={{ margin: "10px 0px 20px 0px" }}
      >
        {title && (
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontSize: theme.typography.customFontSize[6],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
          >
            {title}
          </Typography>
        )}
      </div>
      <Box style={{ marginBottom: "20px" }}>
        <div className={mainStyle["modal_rows"]}>
          <div className={mainStyle["modal_Block"]}>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[4],
                fontWeight: theme.typography.customFontWeight[3],
                fontFamily: theme.typography.fontFamily,
              }}
            >
              Enter the new password
            </Typography>
          </div>
          <div className={mainStyle["modal_Block"]}>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[4],
                fontFamily: theme.typography.fontFamily,
              }}
            >
              Min. 8 haracters with a combination of uppercase letters,
              lowercase letters, numbers, and symbols.
            </Typography>
          </div>
        </div>
        <div className={mainStyle["modal_rows"]}>
          <div style={{ marginTop: "15px" }}>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[4],
                fontFamily: theme.typography.fontFamily,
              }}
            >
              Current Password
            </Typography>
            <Box sx={{}}>
              <TextField
                error={ifNgCurrentPw}
                value={currentPw}
                fullWidth
                placeholder=""
                type={showCurrentPw ? "text" : "password"}
                size="small"
                onChange={(e) => handleCurrentPw(e)}
                onBlur={handleBlurCurrentPw}
                variant="outlined"
                sx={{
                  mr: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px", // 改變圓角
                    "& fieldset": {
                      borderColor: theme.palette.primary.greyThread, // 預設狀態的框線顏色
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.mainHover,
                    },
                    "&.Mui-focused fieldset": {
                      border: "1px solid",
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
                inputProps={{ style: { fontSize: "13px" } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {!showCurrentPw && (
                        <HideIcon
                          onClick={handleShowCurrentPw}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                      {showCurrentPw && (
                        <ShowIcon
                          onClick={handleShowCurrentPw}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                style={{ margin: "5px 0px" }}
              />
            </Box>
            {currentPwErr && (
              <Typography
                sx={{
                  color: theme.palette.primary.redPrimary,
                  fontSize: theme.typography.customFontSize[3],
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                {currentPwErr}
              </Typography>
            )}
          </div>
          <div style={{ marginTop: "15px" }}>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[4],
                fontFamily: theme.typography.fontFamily,
              }}
            >
              New Password
            </Typography>
            <Box sx={{}}>
              <TextField
                error={ifNgNewPw}
                value={newPw}
                fullWidth
                placeholder=""
                type={showNewPw ? "text" : "password"}
                size="small"
                onChange={(e) => handleNewPw(e)}
                onBlur={handleNewPw}
                variant="outlined"
                sx={{
                  mr: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px", // 改變圓角
                    "& fieldset": {
                      borderColor: theme.palette.primary.greyThread, // 預設狀態的框線顏色
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.mainHover,
                    },
                    "&.Mui-focused fieldset": {
                      border: "1px solid",
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
                inputProps={{ style: { fontSize: "13px" } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {!showCurrentPw && (
                        <HideIcon
                          onClick={handleShowNewPw}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                      {showCurrentPw && (
                        <ShowIcon
                          onClick={handleShowNewPw}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                style={{ margin: "5px 0px" }}
              />
            </Box>
            {newPwErr && (
              <Typography
                sx={{
                  color: theme.palette.primary.redPrimary,
                  fontSize: theme.typography.customFontSize[3],
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                {newPwErr}
              </Typography>
            )}
          </div>
          <div style={{ marginTop: "15px" }}>
            <Typography
              sx={{
                color: theme.palette.primary.greyPrimary,
                fontSize: theme.typography.customFontSize[4],
                fontFamily: theme.typography.fontFamily,
              }}
            >
              Confirm Password
            </Typography>
            <Box sx={{}}>
              <TextField
                error={ifNgNewPw2}
                value={newPw2}
                fullWidth
                placeholder=""
                type={showNewPw2 ? "text" : "password"}
                size="small"
                onChange={(e) => handleNewPw2(e)}
                onBlur={handleNewPw2}
                variant="outlined"
                sx={{
                  mr: 1,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px", // 改變圓角
                    "& fieldset": {
                      borderColor: theme.palette.primary.greyThread, // 預設狀態的框線顏色
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.mainHover,
                    },
                    "&.Mui-focused fieldset": {
                      border: "1px solid",
                      borderColor: theme.palette.primary.main,
                    },
                  },
                }}
                inputProps={{ style: { fontSize: "13px" } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {!showCurrentPw && (
                        <HideIcon
                          onClick={handleShowNewPw2}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                      {showCurrentPw && (
                        <ShowIcon
                          onClick={handleShowNewPw2}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                style={{ margin: "5px 0px" }}
              />
            </Box>
            {newPw2Err && (
              <Typography
                sx={{
                  color: theme.palette.primary.redPrimary,
                  fontSize: theme.typography.customFontSize[3],
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                {newPw2Err}
              </Typography>
            )}
          </div>
        </div>
      </Box>
      <div className={mainStyle["modal_Block"]}>
        {cancelBtn && (
          <Box style={{ margin: "10px" }}>
            <OutlineButton width="195px" height="42px" onClick={handleClose}>
              {cancelBtn}
            </OutlineButton>
          </Box>
        )}
        {saveBtn && (
          <Box style={{ margin: "10px" }}>
            <SolidButton width="195px" height="42px" onClick={handleSave}>
              {saveBtn}
            </SolidButton>
          </Box>
        )}
      </div>
      {openSubCheck && (
        <div className={mainStyle["modal_subLayer"]} style={{}}>
          <div className={mainStyle["modal_subContent"]} style={{}}>
            <div
              className={mainStyle["modal_Block"]}
              style={{ margin: "10px" }}
            >
              <Typography
                sx={{
                  color: theme.palette.primary.main,
                  fontSize: theme.typography.customFontSize[5],
                  fontWeight: theme.typography.customFontWeight[3],
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                Do you want to leave?
              </Typography>
            </div>
            <div
              className={mainStyle["modal_Block"]}
              style={{ margin: "10px" }}
            >
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,
                  fontSize: theme.typography.customFontSize[4],
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                You will lose all the input information for change password.
              </Typography>
            </div>
            <div className={mainStyle["modal_Block"]}>
              <Box style={{ margin: "10px" }}>
                <OutlineButton
                  width="100px"
                  height="35px"
                  onClick={handleSubClose}
                >
                  No
                </OutlineButton>
              </Box>
              <Box style={{ margin: "10px" }}>
                <SolidButton width="100px" height="35px" onClick={handleSubOK}>
                  Yes
                </SolidButton>
              </Box>
            </div>
          </div>
        </div>
      )}
      {openFinishLog && (
        <div className={mainStyle["modal_subLayer"]} style={{}}>
          <div className={mainStyle["modal_subContent"]} style={{}}>
            <div
              className={mainStyle["modal_Block"]}
              style={{ margin: "10px" }}
            >
              <Typography
                sx={{
                  color: theme.palette.primary.main,
                  fontSize: theme.typography.customFontSize[5],
                  fontWeight: theme.typography.customFontWeight[3],
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                Password has been Reset
              </Typography>
            </div>
            <div
              className={mainStyle["modal_Block"]}
              style={{ margin: "10px" }}
            >
              <FinishIcon width={70} />
            </div>
            <div
              className={mainStyle["modal_Block"]}
              style={{ margin: "10px" }}
            >
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,
                  fontSize: theme.typography.customFontSize[4],
                  fontFamily: theme.typography.fontFamily,
                }}
              >
                Please click the below button to sign in.
              </Typography>
            </div>
            <div className={mainStyle["modal_Block"]}>
              <Box style={{ margin: "10px" }}>
                <SolidButton
                  width="100px"
                  height="35px"
                  onClick={handleFinishOK}
                >
                  Sign in
                </SolidButton>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(ModalforPassword);
